<div class="landing-container">
    <div class="hero-section">
        <h1>Sistema de Salud Irrecuperable</h1>

        <div class="alert alert-info mt-4" role="alert">
            <strong>Importante:</strong> Debe iniciar sesión con <strong>Clave Única</strong> antes de iniciar cualquier
            trámite.
        </div>
    </div>

    <div class="tramites-grid">
        <div class="card landing-card" (click)="navigateTo('/solicitud-salud-irrecuperable')" role="button">
            <div class="card-body text-center">
                <h3 class="card-title">Evaluación de Salud Irrecuperable de Funcionario Público</h3>
                <p class="card-text text-muted mt-3">Accede a la evaluación de salud irrecuperable de servidores
                    públicos</p>
                <div class="mt-4">
                    <i class="bi bi-file-earmark-check" style="font-size: 2.5rem; color: var(--primary);"></i>
                </div>
            </div>
        </div>
        <div class="card landing-card" (click)="navigateTo('/documentos/presentacion-inicial')" role="button">
            <div class="card-body text-center">
                <h3 class="card-title">Carga de Documentos Inicial</h3>
                <p class="card-text text-muted mt-3">Sube los documentos necesarios para iniciar tu trámite</p>
                <div class="mt-4">
                    <i class="bi bi-cloud-upload" style="font-size: 2.5rem; color: var(--primary);"></i>
                </div>
            </div>
        </div>

        <div class="card landing-card" (click)="navigateTo('/expedientes')" role="button">
            <div class="card-body text-center">
                <h3 class="card-title">Apelación Resolución Evaluación Salud Irrecuperable de Funcionario Público</h3>
                <p class="card-text text-muted mt-3">Gestiona apelaciones y resoluciones de evaluaciones de salud
                    irrecuperable</p>
                <div class="mt-4">
                    <i class="bi bi-exclamation-circle" style="font-size: 2.5rem; color: var(--primary);"></i>
                </div>
            </div>
        </div>


    </div>
</div>